import { useLocation } from "react-router-dom";
import { business, pages } from "../data/business";

/**
 * Route-aware phone resolver — the single source of truth for which number
 * the UI shows and dials.
 *
 * Most of the site is The Outfitter / the lodge campus, which uses
 * `business.phone`. A handful of venues run their own line from a separate
 * physical location (today: Blue Hole BBQ at 130 US Highway 64, which has
 * its own kitchen and its own number). Those declare `phoneOverride` /
 * `phoneRawOverride` in `pages`.
 *
 * Before this hook existed, only `BbqGallery` received the override — every
 * shared chrome component (Nav pill, mobile drawer, Footer, MobileBottomBar,
 * ClosingCta) and even Detail's own CTA buttons hard-referenced
 * `business.phoneRaw`, so a visitor on /bbq who tapped "Call" reached The
 * Outfitter instead of the BBQ. Reading the number through this hook keeps
 * every surface on whichever business the visitor is actually looking at,
 * and any future venue that adds an override is covered automatically.
 */
export function useBusinessPhone() {
  const { pathname } = useLocation();

  // Routes are single-segment (`/:slug`); normalize a trailing slash so
  // "/bbq/" resolves the same as "/bbq".
  const slug = pathname === "/" ? "" : pathname.replace(/\/+$/, "").slice(1);
  const page = pages[slug];

  return {
    phone: page?.phoneOverride ?? business.phone,
    phoneRaw: page?.phoneRawOverride ?? business.phoneRaw,
    /** True when this route belongs to a venue with its own line. */
    isVenueLine: Boolean(page?.phoneRawOverride),
  };
}
